export default "__VITE_ASSET__edb179b9__"